<template>
	<div id="login" class="row justify-content-md-center">
		<div class="col-12 col-md-6 col-xl-4">
		<h1 class="text-center">Login</h1>
			<form v-on:submit.prevent="loginSubmit" class="row login-form ct-form">
				<label class="col-12 col-sm-4">Email</label>
				<input name="email" v-model="email" v-focus class="col-12 col-sm-8 form-control" autocapitalize="off">
				<label class="col-12 col-sm-4">Password</label>
				<input name="password" v-model="password" type="password" v-on:keyup.enter="loginSubmit" class="col-12 col-sm-8 form-control">
				<ButtonWithLoading
				class="mx-auto"
				type="submit"
				:state="loginState"
				text="Log In"
				loadingText="Logging you in"
				successText="Logged In"
				failureText="Problem Logging you in"
				></ButtonWithLoading>
			</form>
			<div class="row justify-content-center">
			<div v-if="errorMessage" class="col-auto err-message alert alert-warning">
				We are having trouble logging you in. Make sure you have verified your email and you have not forgotten your password. Ensure Caps lock is off as your email and password are both case sensitive.
			</div>
			<div class="col-12 text-center my-3">
				<router-link :to="{name:'forgotten', query:{email:this.email}}">
				Forgotten your password?
				</router-link>
			</div>
			</div>
		</div>
		<vue-headful
			title="Login | Cherrytree"
		/>
	</div>
</template>

<script>
import ButtonWithLoading from "@/components/buttonWithLoading";
import { mapState } from "vuex";

export default {
	name: 'Login',
	components: {
		ButtonWithLoading
	},
	data: () => {
		return {
			email:"",
			password:"",
			errorMessage:null,
			loginState: null,
			status: ""
		}
	},
	methods:{
		loginSubmit(){
			this.loginState = "loading"
			let username = this.email
			let password = this.password

			//redirect user after login
			let redirectPath = this.$route.query.redirect || "/"
			//prevent redirect to self, signup, or forgotten password page, verify password, or check email
			if(redirectPath.indexOf("signup") > 0 || redirectPath.indexOf("login") > 0 || redirectPath.indexOf("forgotten") > 0 || redirectPath.indexOf("verify") > 0 || redirectPath.indexOf("check") > 0){
				redirectPath = "/"; //redirect to home
			}
			this.$store.dispatch('auth/login', {username, password})
				.then(() => {

					this.$gtm.trackEvent({
						event: "login"
					})
					// console.log(this.canTransact)
					// console.log(this.last_logged_in)
					if(!this.canTransact) {  // If they have signed up as gold but not brought gold yet, prompt them to do so by taking them to the gold upgrade page
						redirectPath = "/account/gold";
					}
					else if(this.last_logged_in == "0000-00-00 00:00:00") {
						redirectPath = "/account/completeAccount"
					}
					this.$router.replace(redirectPath)
					this.loginState = "success"

				})
				.catch(response => {
					// console.log(response)
					this.$gtm.trackEvent({
						event: "loginFail",
						value: response.error || "Error Logging In"
					})
					if(typeof response.error === 'string'){
						this.status = response.error
					}else{
						this.status = "Error Logging in"
					}
					this.errorMessage=true;
					this.loginState = "failure"
					setTimeout(()=>{ 
						this.loginState = null
					}, 1000)
				})
		}
	},
	computed: {
		...mapState({
			canTransact: state => state.member.canTransact,
			last_logged_in: state => state.member.last_logged_in
		})
	}
}
</script>

<style lang="scss" scoped>
.login-form{
  max-width:700px;
  margin:auto;
}

</style>
